export default {
  account_type: 'Jenis Akaun',
  category: 'Kategori',
  code: 'Kod',
  confirm_password: 'Sahkan Kata Laluan',
  discount_amount: 'Jumlah Diskaun',
  discount_description: 'Huraian Diskaun',
  discount_method: 'Diskaun Kaedah',
  due_date: 'Tarikh Matang',
  full_name: 'Name Penuh',
  gender: 'Jantina',
  id: 'Identiti ID',
  identity_type: 'Jenis Identiti',
  invoice_date: 'Tarikh Invois',
  name: 'Nama',
  nationality: 'Kewarganegaraan',
  password: 'Kata Laluan',
  remark: 'Catatan',
  role: 'Peranan',
  username: 'Nama Pengguna',
  amount_receive: 'Jumlah Diterima',
  amount: 'Amaun',
  customer_name: 'Nama Pelanggan',
  total_no_of_people: 'Jumlah Pelanggan',
  total_no_of_days: 'Jumlah Dhari',
  start_date: 'Tarikh Mula',
  end_date: 'Tarikh Akhir',
  license_no: 'No Akaun / No Lesen',
  email_address: 'Alamat Emel'
}
